<g-content-page [key]="'terms'" fullbleed />
<g-icon
	[icon]="icons.faXmark"
	class="close-dialog"
	(click)="closeDialog()"
	role="button"
	i18n-title
	title="Close"
/>
